import { render, staticRenderFns } from "./MassenmutationModal.vue?vue&type=template&id=3d385385"
import script from "./MassenmutationModal.vue?vue&type=script&lang=js"
export * from "./MassenmutationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports